import { Tab, styled } from "@mui/material"

export const StyledTab = styled((props: any) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  //fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(16),
  marginLeft: theme.typography.pxToRem(26),
  paddingLeft: 0,
  color: "#707070",
  "&.Mui-selected": {
    color: "#000",
    fontWeight: "bold",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "#3C77EF",
  },
}))
